import { cn } from "@/lib/tailwind";
import React from "react";

const Skeleton = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div className={cn("animate-pulse rounded-sm bg-[#ffffff66] p-2", className)}>{children}</div>
  );
};

export default Skeleton;
